import '@fontsource/libre-caslon-text/400.css'
import '@fontsource/libre-caslon-text/700.css'
import '@fontsource/instrument-serif/400.css'
import '@fontsource-variable/geist/index.css'
import '@fontsource-variable/jetbrains-mono/index.css'
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../css/application.css'

const pages = import.meta.glob('../pages/**/*.tsx')

createInertiaApp({
  title: (title) => title ? `${title} - MyCruiseList` : 'MyCruiseList',
  resolve: async (name) => {
    const pageModule = pages[`../pages/${name}.tsx`]
    if (!pageModule) {
      throw new Error(`Page not found: ${name}`)
    }
    const page = await pageModule()
    return page.default
  },
  setup({ el, App, props }) {
    const root = createRoot(el)
    root.render(<App {...props} />)
  },
  progress: {
    color: '#3B82F6',
  },
})
